import cn from 'classnames'
import { memo, useCallback, useState } from 'react'

import { ActiveFiltersMap, DataFilterBar } from 'clickNgo/components/dataFilterBar'
import { Translation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'

import { useFilterConfig } from '../../model/useFilterConfig'
import { partnerContactsTranslation } from '../../translation'

import styles from './FilterPanel.module.scss'

interface Props {
  onFilterChange: (filters: ActiveFiltersMap) => void
  onSearchQueryChange: (query: string) => void
  numberOfFilteredContacts: number
}

export const FilterPanel = memo<Props>(
  ({ onFilterChange, onSearchQueryChange, numberOfFilteredContacts }) => {
    const [filters, setFilters] = useState<ActiveFiltersMap>({})
    const [searchQuery, setSearchQuery] = useState('')
    const { filterConfig } = useFilterConfig()
    const searchIcon = searchQuery ? 'kbase kbase-reload' : 'kbase kbase-search'

    const handleOnSearchReload = useCallback(() => {
      onSearchQueryChange('')
      setSearchQuery('')
    }, [onSearchQueryChange])

    const handleOnSearchChange = useCallback(
      (searchQuery: string) => {
        onSearchQueryChange(searchQuery)
        setSearchQuery(searchQuery)
      },
      [onSearchQueryChange]
    )

    const handleFilterChange = useCallback(
      (newFilters: ActiveFiltersMap) => {
        setFilters(newFilters)
        onFilterChange(newFilters)
      },
      [onFilterChange]
    )

    return (
      <div className={styles.filterPanel}>
        <DataFilterBar
          config={filterConfig}
          value={filters}
          onChange={handleFilterChange}
          buttonVariant="text"
          buttonColor="grey"
          buttonIcon="kbase kbase-bars-filter"
          enableFilterSearch
          filterSearchThreshold={5}
        />
        <div className={styles.search}>
          <div className={styles.foundNumber}>
            <Translation
              text={partnerContactsTranslation.contacts.controls.found}
              replaceParams={[{ key: '{length}', value: `${numberOfFilteredContacts}` }]}
              span
            />
          </div>
          <Input
            label={<Translation text={partnerContactsTranslation.contacts.controls.search} span />}
            value={searchQuery}
            onChange={handleOnSearchChange}
            endContent={
              <span
                onClick={handleOnSearchReload}
                className={cn({ [styles.searchBtn]: searchQuery })}
              >
                <i className={searchIcon} />
              </span>
            }
          />
        </div>
      </div>
    )
  }
)

FilterPanel.displayName = 'FilterPanel'
